import { useLayoutEffect, useRef } from "react";
import Testimonial from "./Testimonial";
import "./Testimonials.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function Testimonials() {
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".testi-head .eyebrow", {
        y: 20, opacity: 0, duration: 0.6, ease: "power3.out",
        scrollTrigger: { trigger: ".testi-head", start: "top 88%" },
      });
      gsap.from(".testi-head h2", {
        y: 30, opacity: 0, duration: 0.7, ease: "power3.out",
        scrollTrigger: { trigger: ".testi-head", start: "top 85%" },
      });
      gsap.from(".testi-card", {
        y: 40, opacity: 0, duration: 0.8, ease: "power3.out",
        scrollTrigger: { trigger: ".testi-card", start: "top 88%" },
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={rootRef} className="testimonials">
      <div className="testimonials-inner">
        <div className="testi-head">
          <span className="eyebrow">Testimonial</span>
          <h2>
            What <span className="grad-text">clients say</span>
          </h2>
        </div>
        <div className="testi-card">
          <Testimonial />
        </div>
      </div>
    </section>
  );
}
